import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid';

//components:
import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { navigate, openDialog, hideDialog } from '../../actions';
import { getEmpresas, deleteEmpresaDB } from '../../actions/empresa_actions';

//material ui:
import { withStyles } from '@material-ui/core/styles';
//import { Tooltip, Fade } from '@material-ui/core';

import * as config from '../../constants/configuration';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    toolbar: {
        display: 'block',
        minHeight: '112px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        marginBottom: 60,
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
        marginLeft: 8,
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaeEmpresa extends Component {

    // constructor(props) {
    //     super(props);

    //     this.state = {
    //         removed: false,
    //     };
    // };

    componentDidMount() {

        if (!this.props.user && config.AUTH) {
            this.props.navigate(""); //go to home page
            return;
        }

        this.props.getEmpresas();
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.refresh !== this.props.refresh && this.props.refresh) {
            this.props.getEmpresas();
        };
    };

    editEmpresa = (empresa) => {
        this.props.navigate("edit_empresa/" + empresa.id);
    };

    newEmpresa = () => {
        this.props.navigate("edit_empresa/" + -1);
    };


    handleDeleteRow = emp => {
        // this.setState({ removed: true })
        this.props.openDialog('ConfirmationDialog', {
            message: '¿Desea borrar definitivamente la empresa ' + this.props.empresas.find(c => c.id === emp.id).empresa1 + '? \n NO es posible deshacer esta operación',
            acceptHandler: () => {
                this.props.deleteEmpresaDB(emp.id);
            }
        }, uuidv4(), false, 'sm');

    };

    render() {

        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <div className={classes.toolbar} />

                    <NeuriteGrid
                        id="m_e"
                        columns={[
                            {
                                key: 'empresa1',
                                name: 'Empresa',
                                editable: false,
                                dragable: false,
                                width: 115
                            },
                            { key: 'direccion1', name: 'Dirección', editable: false, dragable: false, width: 85 },
                            { key: 'cp', name: 'CP', editable: false, dragable: false, width: 65 },
                            { key: 'localidad', name: 'Localidad', editable: false, dragable: false, width: 80 },
                            { key: 'pais', name: 'Pais', editable: false, dragable: false, width: 55 },
                            { key: 'telfCentro', name: 'Teléfono', editable: false, dragable: false, width: 75 },
                            { key: 'emailCentro', name: 'Email', editable: false, dragable: false, width: 70 },
                            { key: 'gerente', name: 'Gerente', editable: false, dragable: false, width: 90 },
                            { key: 'nif', name: 'NIF', editable: false, dragable: false, width: 80 },

                        ]}
                        rows={this.props.empresas}
                        height={500}
                        buttonEdit={true}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newEmpresa}
                        onEditClick={this.editEmpresa}
                        onDeleteClick={this.handleDeleteRow}
                        enableFilter={true}
                    //tooltipFilter='Activar filtros por columna'
                    />
            </div>
        );

    };

};

MaeEmpresa.propTypes = {
    //state
    user: PropTypes.object.isRequired,
    empresas: PropTypes.array.isRequired,
    refresh: PropTypes.bool.isRequired,
    //dispatch
    navigate: PropTypes.func.isRequired,
    getEmpresas: PropTypes.func.isRequired,
    deleteEmpresaDB: PropTypes.func.isRequired,
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {
        user: state.oidc.user,
        empresas: state.empresas.empresas,
        refresh: state.empresas.refresh,
    };
};

function mapDispathToProps(dispatch) {
    return bindActionCreators({
        navigate,
        getEmpresas,
        deleteEmpresaDB,
        openDialog,
        hideDialog,
    }, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispathToProps
)(withStyles(styles, { withTheme: true })(MaeEmpresa));